// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"428":"0bc3ba2fba121d59","2385":"11669ae4b197cacb","2533":"b8517251716410a9","3252":"4d0921b2efaa3fe7"}[chunkId] + ".css";
};